import { isPromotionItem } from 'components/Sell/DiscountBogoDialog/hook/buyXgetYProcess'
import Decimal from 'decimal.js'
import { isEqual } from 'lodash-es'
import {
    DiscountType,
    OrderInventoryStatus,
    OrderLineKdsStatus,
    OrderLineStatus,
    VoidCompReasonType,
} from 'models'
import {
    OrderItemViewModel,
    UsedModifier,
    usedModWithQuantity,
} from 'store/models/sellModels'
import { calculateDiscountAmount } from './orderCalculation/discountCalculation'
import { sortBy } from 'lodash-es'
import { BaseOrderItem } from './orderCalculation/common'
import { isComp } from 'components/Sell/utils/common'

export const updateLineTotalWithDiscount = (orderItem: OrderItemViewModel) => {
    if (orderItem.discounts && orderItem.discounts.length > 0) {
        const discounts = orderItem.discounts
        let lineDiscountAmount = new Decimal(0)
        let remainingPrice = new Decimal(orderItem.lineTotal).times(orderItem.amount)
        sortBy(discounts, (a) =>
            a.type === DiscountType.Percentage ? -1 : 1,
        ).forEach((d) => {
            const discountAmount = calculateDiscountAmount(
                d,
                remainingPrice,
                orderItem.amount,
            )
            lineDiscountAmount = lineDiscountAmount.plus(discountAmount)
            remainingPrice = remainingPrice.sub(discountAmount)
        })
        orderItem.lineTotalWithItemDiscount = remainingPrice.toNumber()
        return
    }
    orderItem.lineTotalWithItemDiscount = orderItem.lineTotal * orderItem.amount
}

export const isVoidedItem = (item: BaseOrderItem | undefined) => {
    return (
        (item?.voidComp && item.voidComp.type === VoidCompReasonType.Void) ||
        false
    )
}
export const isCompItem = (item: BaseOrderItem | undefined) => {
    return isComp(item?.voidComp) || false
}
export const isDraftItem = (
    item:
        | {
              status?: OrderLineStatus
              kdsStatus?: OrderLineKdsStatus
              inventoryStatus?: OrderInventoryStatus
          }
        | undefined,
) => {
    if (!item) return false
    return (
        item.inventoryStatus === OrderInventoryStatus.None &&
        item.kdsStatus === OrderLineKdsStatus.Unknown &&
        item.status === OrderLineStatus.New
    )
}
export const disableModifyItem = (item: OrderItemViewModel | undefined) => {
    return (
        !item ||
        isVoidedItem(item) ||
        !isDraftItem(item) ||
        isPromotionItem(item)
    )
}

export const sumSubModifierQuantity = (
    usedMod: usedModWithQuantity,
    bind: string,
): usedModWithQuantity[] => {
    return usedMod.subModifierOptions[bind].reduce<usedModWithQuantity[]>(
        (newMod, cur) => {
            const existMod = newMod.find(
                (mod) => mod.modifierOptionId === cur.modifierOptionId,
            )
            if (existMod) existMod.quantity++
            else
                newMod.push({
                    modifierGroupId: cur.modifierGroupId,
                    modifierOptionId: cur.modifierOptionId,
                    quantity: 1,
                    addPrice: cur.addPrice,
                    subModifierOptions: {},
                })
            return newMod
        },
        [],
    )
}

export const sumModifierQuantity = (
    useMo: UsedModifier[],
): usedModWithQuantity[] => {
    return useMo.reduce<usedModWithQuantity[]>((newMod, cur) => {
        const existMod = newMod.find(
            (mod) =>
                mod.modifierOptionId === cur.modifierOptionId &&
                isEqual(mod.subModifierOptions, cur.subModifierOptions),
        )
        if (existMod) existMod.quantity++
        else newMod.push({ ...cur, quantity: 1 })
        return newMod
    }, [])
}
